import React, { useEffect, useState } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import ShipDateDropdown from '../../sharedComponents/ShipDateDropdown';
import { toast } from 'react-toastify';
import useManageWeeklyShip from '../weeklyShip/useManageWeeklyShip';
import CircularProgress from '@mui/material/CircularProgress';


const WeeklyShip = () => {
  const columnDefs = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      width: 50,
      sortable: false,
    },
    { headerName: 'No', field: 'ojNo', flex: 1 },
    { headerName: 'Arrvied Date', field: 'arrivedDate', flex: 1 },
    { headerName: 'Box Name', field: 'boxName', flex: 1 },
    { headerName: 'Smile Name', field: 'smileNameInput', flex: 1 },
    { headerName: 'Tracking No.', field: 'trackingJp', flex: 1 },
    { headerName: 'Contact', field: 'contact', flex: 1 },
    { headerName: 'COD', field: 'codPrice', flex: 1 },
    { headerName: 'Weight', field: 'weight', flex: 1 },
    { headerName: 'Box No.', field: 'boxNo', flex: 1 },
    { headerName: 'Ship Date', field: 'shipDate', flex: 1 },
  ];
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [shipDateId, setShipDateId] = useState('')
  const {shipDates, 
    isLoading,
    refreshWeeklyShipDates,
    deleteWeeklyShipDates
  } = useManageWeeklyShip()

  function handleRowSelection() {
    const selectedNodes = gridOptions.api.getSelectedNodes();
    const keys = selectedNodes.map(node => node.data.uuid);
    setSelectedKeys(keys);  // Setting the state
  }

  const [gridOptions, setGridOptions] = useState({
    rowSelection: 'multiple', // this can be 'single' for single row selection
    suppressColumnVirtualisation: true, // render all columns so browser Ctrl+F/Cmd+F can find them
  });

  const handleSelectChange = (e) => {
    setShipDateId(e.target.value)
    refreshWeeklyShipDates(e.target.value)
  }

  const handleDeleteClick = async () => {
    if(setSelectedKeys.length){
      const response = await deleteWeeklyShipDates(selectedKeys)
      toast.success(response)
      refreshWeeklyShipDates(shipDateId);
    }else{
      console.log('fail');
    }
  }

  useEffect(() => {
    const formattedOrders = shipDates.map(shipDate => ({
    ...shipDate, // spread the other properties of the order
    contact: shipDate.Orders && shipDate.Orders.length > 0 && shipDate.Orders[0].CustomerProfile ? shipDate.Orders[0].CustomerProfile.contact : "",
    smileNameInput: shipDate.Orders && shipDate.Orders.length > 0 ? shipDate.Orders[0].smileNameInput : ""
  }));
    setRowData(formattedOrders)
  }, [shipDates]);
  
  const handleCopyClick = () => {
    if (rowData && rowData.length > 0) {
      // Format each row's data and join them with new line
      const copyData = rowData.map(row => {
        return `${row.boxNo}\t${row.smileNameInput}\t${row.contact}`;  // Tab-separated values
      }).join('\n');  // New line for each row
  
      navigator.clipboard.writeText(copyData)
        .then(() => {
          toast.success('All data copied to clipboard!');
        })
        .catch(err => {
          toast.error('Failed to copy data: ' + err.message);
        });
    } else {
      toast.warn('No data available to copy');
    }
  };

  const handleOverSizeClick = () => {
    if (rowData && rowData.length > 0) {
      // Filter records where isOversize is true
      const overSizeRecords = rowData.filter(row => row.isOversize === true);
      
      if (overSizeRecords.length === 0) {
        toast.warn('No over size records found');
        return;
      }

      // Get the ship date from the first record (assuming all records have the same ship date)
      const shipDate = overSizeRecords[0].shipDate || 'Unknown';
      
      // Create the formatted text with new format
      let copyData = `รบกวนวัดขนาดกล่องสินค้า\nรอบเรือ ${shipDate}\n\n`;
      
      // Add each over size record with new format
      overSizeRecords.forEach((row, index) => {
        copyData += `ชื่อกล่อง ${row.boxName || ''}\n`;
        copyData += `เลขกล่อง ${row.boxNo || ''}\n`;
        if (index < overSizeRecords.length - 1) {
          copyData += `-----------------\n`;
        }
      });

      navigator.clipboard.writeText(copyData)
        .then(() => {
          toast.success('Over size data copied to clipboard!');
        })
        .catch(err => {
          toast.error('Failed to copy over size data: ' + err.message);
        });
    } else {
      toast.warn('No data available to copy');
    }
  };
  

  return (
    <div className="ag-theme-alpine container mx-auto" style={{ width: '100%' }}>
      <h2>Weekly Ship</h2>
        <div className='flex justify-between'>
          <ShipDateDropdown 
            handleDataChange={handleSelectChange}
            includeDefault={true}
          />
          {isLoading && <CircularProgress />} {/* Render spinner when loading */}
          <div className='flex gap-2'>
            <button className='btn-success' onClick={handleOverSizeClick}>
              Over Size
            </button>
            <button className='btn-primary' onClick={handleCopyClick}>
              Copy
            </button>
            <button className='btn-danger' onClick={handleDeleteClick}>
              Delete
            </button>
          </div>
        </div>
      <div style={{ height: 300, marginTop: '10px' }}>
        <AgGridReact
          gridOptions={gridOptions}
          columnDefs={columnDefs}
          rowData={rowData}
          domLayout='autoHeight'
          defaultColDef={{ resizable: true, sortable: true }}
          onSelectionChanged={handleRowSelection}
          enableCellTextSelection={true}
        />
      </div>
    </div>
  );
}

export default WeeklyShip;
